import React from 'react';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import { ChevronRight } from '@saleshandy/icons';

import { accessibleOnClick } from '../../../../../../shared/utils/accessible-on-click';
import { RootState } from '../../../../../../store/root-reducer';
import { formatPhoneNumber } from '../../../../helpers/utils/get-formated-numbers';

const PhoneNumberSettingsHeader: React.FC = () => {
  const history = useHistory();

  const onTitleClick = () => {
    history.push('/dialer/phone-numbers');
  };
  const activeNumberSettings = useSelector((state: RootState) => state.dialer.activeNumberSettings);
  const formattedPhoneNumber = formatPhoneNumber(activeNumberSettings?.phoneNumber, 'US');

  return (
    <div className="d-flex justify-content-between align-items-center">
      <div className="create-email-infrastructure-header d-flex align-items-center">
        <p
          className="create-email-infrastructure-header--title"
          {...accessibleOnClick(onTitleClick)}
        >
          Phone Numbers
        </p>
        <div className="create-email-infrastructure-header--icon d-flex justify-content-center align-items-center">
          <ChevronRight />
        </div>
        <p className="create-email-infrastructure-header--title">
          {formattedPhoneNumber
            ? `Number Settings (${formattedPhoneNumber})`
            : 'Number Settings'}
        </p>
        {activeNumberSettings?.isPrimaryNumber && (
        <div className="badge-chip primary">
          <span>Primary</span>
        </div>
        )}
        {activeNumberSettings?.isFreeNumber && (
        <div className="badge-chip free">
          <span>Free</span>
        </div>
        )}
      </div>
    </div>
  );
};

export default PhoneNumberSettingsHeader;

